'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import { useAuth } from '@/hooks/useAuth';
import LoginModal from '@/app/booking-confirmation/components/LoginModal';

interface ViewDashboardButtonProps {
  className?: string;
}

export default function ViewDashboardButton({ className = '' }: ViewDashboardButtonProps) {
  const router = useRouter();
  const { isAuthenticated } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleClick = () => {
    if (isAuthenticated) {
      router.push('/tourist-dashboard');
      return;
    }
    setShowLoginModal(true);
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    router.push('/tourist-dashboard');
  };

  return (
    <>
      <button data-component-id="src/app/components/ViewDashboardButton.tsx:33:6" data-component-path="src/app/components/ViewDashboardButton.tsx" data-component-line="33" data-component-end-line="40" data-component-file="ViewDashboardButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
        type="button"
        onClick={handleClick}
        className={className}
      >
        <span data-component-id="src/app/components/ViewDashboardButton.tsx:38:8" data-component-path="src/app/components/ViewDashboardButton.tsx" data-component-line="38" data-component-end-line="38" data-component-file="ViewDashboardButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22View%20Dashboard%22%7D">View Dashboard</span>
        <Icon data-component-id="src/app/components/ViewDashboardButton.tsx:39:8" data-component-path="src/app/components/ViewDashboardButton.tsx" data-component-line="39" data-component-end-line="39" data-component-file="ViewDashboardButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22UserIcon%22%7D" name="UserIcon" size={20} />
      </button>

      <LoginModal data-component-id="src/app/components/ViewDashboardButton.tsx:42:6" data-component-path="src/app/components/ViewDashboardButton.tsx" data-component-line="42" data-component-end-line="46" data-component-file="ViewDashboardButton.tsx" data-component-name="LoginModal" data-component-content="%7B%22elementName%22%3A%22LoginModal%22%7D"
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
}

